import * as $ from "jquery";

export default class ContentBlock
{
    private stepList: JQuery[];

    private step: number;

    private observerState: (state: any) => void;

    constructor()
    {
        let stepList: JQuery[] = [];
        jQuery('[data-content-block-step]').each(function() {
            let stepIndexList = jQuery(this).attr('data-content-block-step').split(','),
                stepIndex: string,
                index: number;
            for (stepIndex of stepIndexList) {
                index = parseInt(stepIndex);
                if (typeof stepList[index] === "undefined") {
                    stepList[index] = jQuery();
                }
                Array.prototype.push.call(stepList[index], this);
            }
        });
        this.step = 0;
        this.stepList = stepList;
    }

    setStep(step: number)
    {
        if (typeof this.stepList[step] !== "undefined") {
            this.stepList[this.step].attr('hidden', 'hidden');
            this.step = step;
            this.stepList[step].removeAttr('hidden');
            if (this.observerState) {
                this.observerState(step);
            }
            return true;
        }
        return false;
    }

    do(name: string)
    {
        if (name === 'prev') {
            return this.setStep(this.step - 1);
        } else if (name === 'next') {
            return this.setStep(this.step + 1);
        } else if (name === 'show') {
            return this.setStep(1);
        } else if (name === 'hide') {
            return this.setStep(0);
        } else {
            throw new Error();
        }
    }

    onChangeStep(callback: (step: any) => void): void
    {
        this.observerState = callback;
    }
}